import * as i0 from "@angular/core";
var QuerifyService = /** @class */ (function () {
    function QuerifyService() {
    }
    QuerifyService.prototype.transformOptions = function (query, options) {
        options = options || {};
        if (options['orderLegacy'] === false) {
            return {
                where: query,
                orderBy: {
                    column: options['orderColumn'],
                    operator: options['operator'],
                    value: options['value'],
                    direction: options['order']
                },
                limit: Number(options['limit']) || 50,
                offset: Number(options['offset']) || 0
            };
        }
        return {
            where: query,
            orderBy: options['order'] ? options['orderColumn'] + "_" + options['order'] : null,
            limit: Number(options['limit']) || 50,
            offset: Number(options['offset']) || 0
        };
    };
    QuerifyService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function QuerifyService_Factory() { return new QuerifyService(); }, token: QuerifyService, providedIn: "root" });
    return QuerifyService;
}());
export { QuerifyService };
